import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import ReactTableWrapper from '../../ReactTableWrapper';
import Numeral from 'numeral';
import { __regionCurrencyDisplay } from '../../../_utils';

function CartRuleList(props) {
    const { isLoading, list, onRemoveClick, onEditClick, showForm } = props;
    const [
        showRemoveConfirmationModal,
        setShowRemoveConfirmationModal,
    ] = useState({});
    const [isDeleting, setIsDeleting] = useState({});

    /**
     * Toggle isDeleting value
     *
     * @param key
     * @param value
     */
    const toggleIsDeleting = (key, value) => {
        setIsDeleting((prevState) => {
            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    /**
     * Handler when user confirms removing a row
     *
     * @param row
     */
    const onConfirmRemoveRow = (row) => {
        const identifier = row.original.ID;

        toggleShowRemoveConfirmationModal(row, false);
        toggleIsDeleting(identifier, true);

        onRemoveClick(identifier, {
            always: () => {
                toggleIsDeleting(identifier, false);
            },
        });
    };

    /**
     * Toggle the show remove confirmation modal
     *
     * @param row
     * @param value
     */
    const toggleShowRemoveConfirmationModal = (row, value) => {
        const { viewIndex } = row;

        setShowRemoveConfirmationModal({
            ...showRemoveConfirmationModal,
            [viewIndex]: value,
        });
    };

    /**
     * Check if we are showing remove confirmation on this row
     *
     * @param row
     * @returns {boolean}
     */
    const getRemoveConfirmation = (row) => {
        const { viewIndex } = row;

        return typeof showRemoveConfirmationModal[viewIndex] != 'undefined'
            ? showRemoveConfirmationModal[viewIndex]
            : false;
    };

    /**
     * Get the React Table props
     *
     * @returns {{list: {columns: *[], showPagination: boolean}}}
     */
    const getTableProps = () => {
        // const lessThanMD = wWidth < breakpoints.md;
        const tableProps = {
            list: {
                columns: [
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'FIELD.CARTRULE_TITLE'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-postmen__carrier-name',
                        className: 'rt-postmen__carrier-name',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Title',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'FIELD.CARTRULE_DISCOUNT'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                       {row.value}%
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-postmen__carrier-name',
                        className: 'rt-postmen__carrier-name',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Discount',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'FIELD.CARTRULE_MIN_AMOUNT'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {__regionCurrencyDisplay(row.value)}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-postmen__carrier-name',
                        className: 'rt-postmen__carrier-name',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'MinimumAmount',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'FIELD.CARTRULE_ENABLED'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value ? 'Enabled' : 'Disabled'}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'rt-postmen__carrier-status',
                        className: 'rt-postmen__carrier-status',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Enabled',
                    },
                    {
                        Cell: (row) => {
                            const identifier = row.original.ID;
                            const isColumnLoading =
                                typeof (isDeleting != 'undefined') &&
                                typeof isDeleting[identifier] != 'undefined'
                                    ? isDeleting[identifier]
                                    : false;

                            // if(!row.original.CanEdit) {
                            //     return '';
                            // }

                            if (showForm !== 'default') {
                                return '';
                            }

                            return (
                                <React.Fragment>
                                    {isColumnLoading ? (
                                        <ReactLoading
                                            type='spin'
                                            color='black'
                                            height={20}
                                            width={20}
                                        />
                                    ) : (
                                        <a
                                            className='button button--thin button--small button--light-grey'
                                            onClick={(e) => onEditClick(row)}
                                        >
                                            <LocalizedMessage id={'EDIT'} />
                                        </a>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__edit-col hidden-xs',
                        className: 'react-table__edit-col hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        // accessor: 'IsEdit',
                    },
                    {
                        Cell: (row) => {
                            const identifier = row.original.ID;
                            const isColumnLoading =
                                typeof (isDeleting != 'undefined') &&
                                typeof isDeleting[identifier] != 'undefined'
                                    ? isDeleting[identifier]
                                    : false;

                            // if(!row.original.CanDelete) {
                            //     return '';
                            // }

                            if (showForm !== 'default') {
                                return '';
                            }

                            return (
                                <React.Fragment>
                                    {isColumnLoading ? (
                                        <ReactLoading
                                            type='spin'
                                            color='black'
                                            height={20}
                                            width={20}
                                        />
                                    ) : (
                                        <button
                                            type='button'
                                            className='button-link-plain button-link-plain--light-grey button-link-plain--small'
                                            onClick={(e) =>
                                                toggleShowRemoveConfirmationModal(
                                                    row,
                                                    true
                                                )
                                            }
                                        >
                                            <span className='icon icon-bin-thick' />
                                        </button>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__remove-col hidden-xs',
                        className: 'react-table__remove-col hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        // accessor: 'IsDelete',
                    },
                ],
                showPagination: false,
            },
        };

        return tableProps;
    };

    return (
        <ReactTableWrapper
            loading={isLoading}
            data={list}
            reactTable={getTableProps()}
            hasRemoveConfirmation={true}
            toggleRemoveConfirmation={toggleShowRemoveConfirmationModal}
            getRemoveConfirmation={getRemoveConfirmation}
            onRemoveRow={onConfirmRemoveRow}
        />
    );
}

export default CartRuleList;
